<template>
<div id="bo-import-main">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>{{ subtitle }}</small>
        <br>
        {{ title }}
      </h1>
      <hr>
    </div>
  </div>
  <div class="panel panel-info">
    <div class="panel-heading">
      <div class="form-inline">
        <div class="form-group">
          <btn class="btn-primary"
               @click="$refs.fileInput.click()">
            Importer depuis un .csv
            <input ref="fileInput"
                   v-show="false"
                   type="file"
                   @change="importFromCSV"
                   single>
          </btn>
        </div>
        <div class="form-group">
          <btn type="warning" @click="askForAllRemoval()">Tout supprimer</btn>
        </div>
        <div class="form-group">
          <btn type="success"
               @click="askForCommit()"
               :disabled="this.all.length === 0">
            Enregistrer les utilisateurs importés
          </btn>
        </div>
      </div>
    </div>
  </div>
  <bo-import-csv :csvFile="csvFile"
                 :mandatoryColumns="mandatoryCSVColumns"
                 @import-ok="loadTable($event)">
  </bo-import-csv>
  <sui-table :columns="table.columns"
            :actions="table.actions"
            :keyfield="table.keyfield"
            :list="all"
            :title="title"
            :showFilter="false"
            @remove="askForRemoval($event)"></sui-table>

  <modal v-model="commit.modal" @hide="commitModalEnded" title="Confirmation"
         ok-text="Oui" cancel-text="Non" ok-type="danger" cancel-type="primary">
    Êtes vous certain.e de vouloir enregistrer tous les utilisateurs de la
    liste d'import dans la base de donnée ?
  </modal>

  <modal v-model="commit.logs.modal" :keyboard="false" :backdrop="false"
         :dismiss-btn="false" title="Enregistrement en cours">
    <alert v-if="commit.running"
           type="info">
      <p>Enregistrement des utilisateurs en cours... {{ commit.count }} / {{ commit.length }}</p>
    </alert>
    <alert v-else
           :type="commit.logs.logs.length === 0 ? 'success' : 'danger'">
      <p>Enregistrement terminé.</p>
    </alert>
    <bo-import-logs :logs="commit.logs.logs" />
    <div slot="footer">
      <btn v-if="!open.done"
           type="success"
           :disabled="commit.running"
           @click="openAccounts">
        Ouvrir les comptes insérés
      </btn>
      <btn :disabled="commit.running" @click="dismissCommitModal">Quitter</btn>
    </div>
  </modal>

  <modal v-model="open.modal" @hide="openAccountsModalEnded" title="Confirmation"
         ok-text="Oui" cancel-text="Non" ok-type="danger" cancel-type="primary">
    <p>
      Êtes vous certain.e de vouloir ouvrir les comptes des utilisateurs suivants :
    </p>
    <ul>
      <li v-for="(a, k) in open.accounts"
          :key="k">
        {{ a.firstName }} {{ a.name }}
      </li>
    </ul>
  </modal>

  <modal v-model="remove.modal" @hide="removeModalEnded" title="Confirmation"
         ok-text="Oui" cancel-text="Non" ok-type="danger" cancel-type="primary">
    <p v-if="remove.user != null">
      Êtes vous certain.e de vouloir supprimer l'utilisateur
      {{ remove.user.firstName }} {{ remove.user.name }} de la liste
      d'import ?
    </p>
    <p v-else>
      Êtes vous certain.e de vouloir supprimer tous les utilisateurs de la
      liste d'import ?
    </p>
  </modal>
</div>
</template>

<script>
import suiTable from '@/sui/components/table'
import boImportLogs from '@/components/import/logs'
import boImportCSV from '@/components/import/csv'

export default {
  name: 'bo-import',
  props: {
    title: String,
    subtitle: String,
    storePrefix: String,
    routePrefix: String,
    columns: Array,
    defaultRoles: Array
  },

  data () {
    return {
      csvFile: null,
      all: [],

      commit: {
        modal: false,
        logs: {
          modal: false,
          logs: []
        },
        index: 0,
        count: 0,
        length: 0,
        ended: 0,
        running: false
      },

      remove: {
        modal: false,
        user: null
      },

      open: {
        modal: false,
        done: false,
        accounts: []
      },

      table: {
        columns: this.columns,
        keyfield: 'id',
        actions: [
          {
            event: 'remove',
            name: 'Supprimer'
          }
        ]
      }
    }
  },

  computed: {
    mandatoryCSVColumns () {
      const reducer = (result, u) => {
        if (u.mandatory) { result.push(u) }
        return result
      }
      return this.table.columns.reduce(reducer, [])
    }
  },

  methods: {
    importFromCSV: function (event) {
      this.csvFile = event.target.files[0]
      this.$refs.fileInput.value = ''
    },

    loadTable: function (event) {
      this.all = event
    },

    askForCommit: function () {
      this.commit.modal = true
    },

    commitModalEnded: function (msg) {
      if (msg === 'ok') {
        this.commitUsers()
      }
    },

    commitUsers: function () {
      this.commit.logs.modal = true
      this.commit.running = true
      this.commit.index = 0
      this.commit.count = 0
      this.commit.length = this.all.length
      this.commit.ended = 0
      this.commit.logs.logs = []
      this.open.accounts = []
      setTimeout(this.continueCommit(), 10)
    },

    continueCommit: function () {
      const parallelCount = 5

      while (this.commit.count !== this.commit.length &&
             this.commit.count - this.commit.ended < parallelCount) {
        const user = this.all[this.commit.count]
        const request = {
          n: user.name,
          f: user.firstName,
          r: (user.roles != null) ? user.roles : this.defaultRoles,
          em: user.email,
          i: user.info
        }

        let instance = this
        this.$store.dispatch(`${this.storePrefix}/add`, request).then(
          (response) => {
            if (response.data.err != null) {
              instance.commit.logs.logs.push({
                text: `Impossible d'insérer ${request.em}: ${response.data.err}`,
                type: 'danger'
              })
            } else {
              instance.open.accounts.push(user)
            }
            ++instance.commit.ended
            setTimeout(instance.continueCommit(), 10)
          }
        ).catch(function (e) {
          instance.commit.logs.logs.push({
            text: `Impossible d'insérer ${request.em}: ${e}`,
            type: 'danger'
          })
          ++instance.commit.ended
          setTimeout(instance.continueCommit(), 10)
        })
        ++this.commit.count
      }
      this.commit.running = this.commit.ended !== this.commit.length
    },

    askForAllRemoval: function () {
      this.remove.modal = true
      this.remove.user = null
    },

    askForRemoval: function (u) {
      this.remove.modal = true
      this.remove.user = u
    },

    openAccounts: function () {
      this.open.modal = true
    },

    openAccountsModalEnded: function (msg) {
      if (msg === 'ok') {
        this.commit.running = true
        this.open.done = true
        this.commit.index = 0
        this.commit.count = 0
        this.commit.length = this.open.accounts.length
        this.commit.ended = 0
        this.commit.logs.logs = []
        setTimeout(this.continueOpenAccount(), 10)
      }
    },

    continueOpenAccount: function () {
      const parallelCount = 5
      while (this.commit.count !== this.commit.length &&
             this.commit.count - this.commit.ended < parallelCount) {
        const user = this.open.accounts[this.commit.count]
        const request = {
          name: user.name,
          firstName: user.firstName,
          email: user.email[0],
          source: true,
          prefix: this.routePrefix
        }

        let instance = this
        this.$store.dispatch(`password/init`, request).then(
          (response) => {
            if (response.data.err != null) {
              instance.commit.logs.logs.push({
                text: `Impossible d'ouvrir le compte de ${request.email}: ${response.data.err}`,
                type: 'danger'
              })
            }
            ++instance.commit.ended
            setTimeout(instance.continueOpenAccount(), 10)
          }
        ).catch(function (e) {
          instance.commit.logs.logs.push({
            text: `Impossible d'ouvrir le compte de ${request.email}: ${e}`,
            type: 'danger'
          })
          ++instance.commit.ended
          setTimeout(instance.continueCommit(), 10)
        })
        ++this.commit.count
      }
      this.commit.running = this.commit.ended !== this.commit.length
    },

    removeModalEnded: function (msg) {
      if (msg === 'ok') {
        if (this.remove.user != null) {
          this.removeUser(this.remove.user.id)
        } else {
          this.removeAll()
        }
      }
      this.remove.user = null
    },

    removeUser: function (id) {
      const pos = this.all.findIndex(e => { return e.id === id })

      if (pos === -1) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          content: `Impossible de supprimer l'utilisateur ${id}.`
        })
      } else {
        this.all.splice(pos, 1)
        this.$notify({
          type: 'success',
          title: 'Succès !',
          content: `Utilisateur ${id} supprimé avec succès.`
        })
      }
    },

    removeAll: function () {
      const count = this.all.length
      this.all = []
      this.$notify({
        type: 'success',
        title: 'Succès !',
        content: `${count} lignes supprimées avec succès.`
      })
    },

    dismissCommitModal: function () {
      this.all = []
      this.commit.logs.modal = false
    }
  },

  components: {
    'sui-table': suiTable,
    'bo-import-logs': boImportLogs,
    'bo-import-csv': boImportCSV
  }
}
</script>

<style>
</style>
